import React, { useEffect } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { useWindowResizeEvent } from '@wix/da-hooks/pkg/useWindowResizeEvent';
import { DeviationViewContext } from '../../Context';
import StashPageContent from '../_partials/StashPageContent';
import SiteFooter from '../../SiteFooter';
import { DeviationViewMode } from '@wix/da-react-context/pkg/publicSession';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { SubscriptionPurchaseFTUEContextProvider } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { getBiEventComponentByType } from '../redux/helpers';
import { getDeviationType, getDeviationResourceType } from '../../DeviationViews/_helpers';
import Notifications from '../../Notifications';
import { useDeviationChangedCallback } from '../hooks/useDeviationChangedCallback';
import DeviationPageHeader from '../_partials/DeviationPageHeader';
import DeviationPageLoader from '../_partials/DeviationPageLoader';
import { MatureDeviationContextProvider } from '../../Context/MatureDeviationContext';
import deviationPageStyles from '../DeviationPage.scss';
import s from './StashPage.scss';

export interface Props {
  deviation?: PapiDeviation;
  viewMode: DeviationViewMode;
  onLoad: (deviation: PapiDeviation) => void;
  onScreenResize: (width: number, height: number) => void;
}

const StashPage: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  onLoad,
  viewMode,
  onScreenResize,
}) => {
  useWindowResizeEvent(onScreenResize);
  useDeviationChangedCallback(deviation, onLoad);

  useEffect(() => {
    onScreenResize(window.innerWidth, window.innerHeight);
  }, [onScreenResize]);

  const biComponent = getBiEventComponentByType(getDeviationType(deviation));

  return (
    <DeviationViewContext.Provider value={viewMode}>
      <main role="main" className={classnames(deviationPageStyles['root'])}>
        <DeviationPageHeader />

        {!deviation && <DeviationPageLoader />}
        {deviation && (
          <BiLoggerContextProvider
            value={{
              view: 'stash',
              typeid: getDeviationResourceType(deviation),
              itemid: deviation.deviationId,
              page_typeid: getDeviationResourceType(deviation),
              page_itemid: deviation.deviationId,
              creatorid: deviation.author?.useridUuid ?? '',
              component: biComponent,
              sectionname: 'stash',
            }}
          >
            <MatureDeviationContextProvider deviation={deviation}>
              <SubscriptionPurchaseFTUEContextProvider deviation={deviation}>
                <StashPageContent deviation={deviation} />
              </SubscriptionPurchaseFTUEContextProvider>
            </MatureDeviationContextProvider>
          </BiLoggerContextProvider>
        )}

        <SiteFooter />
      </main>
      <Notifications
        wrapperClassName={classnames(
          viewMode === DeviationViewMode.Normal && s['stage-notifications']
        )}
      />
    </DeviationViewContext.Provider>
  );
};
StashPage.displayName = 'StashPage';

export default StashPage;
